import { Button, DuplicateIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDuplicateDesignMapping } from "../../hooks/designMappings/useDuplicateDesignMapping";

type DesignMappingDuplicateButtonProps = {
  designMappingId: string;
};

export const DesignMappingDuplicateButton: React.FC<
  DesignMappingDuplicateButtonProps
> = ({ designMappingId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [duplicateDesignMapping, isLoading] =
    useDuplicateDesignMapping(designMappingId);

  return (
    <Button
      key="design-mapping-duplicate"
      icon={<DuplicateIcon />}
      onClick={async () => {
        const design = await duplicateDesignMapping();

        if (design) {
          navigate(`/design-mappings/${design.id}`);
        }
      }}
      loading={isLoading}
    >
      {t("designMappings.actions.duplicate.button")}
    </Button>
  );
};
